<script setup lang="ts">
import type { CmsElementPluebelCmsElementsColorcombinations } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementPluebelCmsElementsColorcombinations;
}>();
const { headline, colorswatch, bg_hexcode } = props.content.config;

const isSliderReady = ref(false);
onMounted(() => {
  isSliderReady.value = true;
});
const productSlider = ref(null);
const colorworldBoxesSwiperSlider = useSwiper(productSlider, {
  effect: "slide",
  loop: true,
  grabCursor: true,
  autoplay: {
    delay: 3000,
  },
  centeredSlides: false,
  slidesPerView: 3,
  breakpoints: {
    540: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
  },
});
</script>

<template>
  <section class="faq-section pb-20 md:pb-24 xl:pb-36">
    <div class="container">
      <h3>{{ headline.value }}</h3>
      <div
        class="text-left cat-slider sm:-mx-3 md:-mx-4 m-0 relative"
        v-if="isSliderReady"
      >
        <div
          class="h-[100px] w-full absolute top-[60px]"
          :style="{ backgroundColor: bg_hexcode.value }"
        ></div>
        <div
          v-if="colorswatch.value?.length"
          @click="colorworldBoxesSwiperSlider.prev()"
          class="swiper-cust-button-prev bg-cust_cream text-cust_gray03 mt-5"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </div>
        <swiper-container ref="productSlider">
          <swiper-slide
            v-for="(colorwatchBox, index) in colorswatch.value"
            :key="index"
            class="p-4"
          >
            <div class="text-left font-bold text-lg mb-10">
            </div>
            <template v-if="colorwatchBox.color_hexcode">
              <div class="pt-10 flex flex-col items-center">
                <div
                  class="mb-6 relative w-32 h-[198px] border border-white"
                  :style="{ backgroundColor: colorwatchBox.color_hexcode }"
                ></div>

                <SharedButton
                  v-if="
                    colorwatchBox.productlink && colorwatchBox.productlink.url
                  "
                  :button="{
                    ...colorwatchBox.productlink,
                    title:
                      colorwatchBox.productlink.title ||
                      colorwatchBox.colorswatchbox_title,
                  }"
                  class="text-center font-normal"
                />
                <p v-else class="text-center font-normal">
                  {{ colorwatchBox.title_below }}
                </p>
              </div>
            </template>
          </swiper-slide>
        </swiper-container>
        <div
          v-if="colorswatch.value?.length"
          @click="colorworldBoxesSwiperSlider.next()"
          class="swiper-cust-button-next bg-cust_cream text-cust_gray03 mt-5"
        >
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </div>
      <div v-else class="flex">
        <div
          v-for="index in 4"
          :key="index"
          data-testid="loading"
          class="w-1/2 lg:w-1/3 xl:w-1/4 px-2"
        >
          <ProductCardSkeleton class="w-full mb-8 px-1 sm:mr-8 mb-8" />
        </div>
      </div>
    </div>
  </section>
</template>
